(function () {
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-lpb-subscription-showcase]'));

  if (!sections.length) {
    return;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  /* ---------- Apple-style feature menu (gift options) ---------- */
  function setupFeatureMenu(section) {
    var root = section.querySelector('[data-lpb-feature]');

    if (!root) {
      return;
    }

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lpb-feature-item]'));
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lpb-feature-trigger]'));
    var visuals = Array.prototype.slice.call(root.querySelectorAll('[data-lpb-feature-visual]'));
    var prevBtn = root.querySelector('[data-lpb-feature-prev]');
    var nextBtn = root.querySelector('[data-lpb-feature-next]');

    if (!items.length) {
      return;
    }

    var activeIndex = items.reduce(function (found, item, index) {
      return item.classList.contains('is-active') ? index : found;
    }, 0);

    function visualFor(id) {
      return visuals.filter(function (visual) {
        return visual.getAttribute('data-lpb-feature-visual') === id;
      })[0];
    }

    function activate(index) {
      index = clamp(index, 0, items.length - 1);
      activeIndex = index;

      items.forEach(function (item, i) {
        var isActive = i === index;
        var id = item.getAttribute('data-lpb-feature-item');
        var trigger = item.querySelector('[data-lpb-feature-trigger]');
        var visual = visualFor(id);

        item.classList.toggle('is-active', isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (visual) {
          visual.classList.toggle('is-active', isActive);
        }
      });

      if (prevBtn) {
        prevBtn.disabled = index <= 0;
      }

      if (nextBtn) {
        nextBtn.disabled = index >= items.length - 1;
      }
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        activate(index);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          var next = clamp(index + 1, 0, triggers.length - 1);
          activate(next);
          triggers[next].focus();
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          var prev = clamp(index - 1, 0, triggers.length - 1);
          activate(prev);
          triggers[prev].focus();
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activate(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate(activeIndex + 1);
      });
    }

    activate(activeIndex);
  }

  /* ---------- Hero explore spots (NBA-style hotspots) ---------- */
  function setupExploreSpots(section) {
    var root = section.querySelector('[data-lpb-explore]');

    if (!root) {
      return;
    }

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lpb-spot-trigger]'));

    if (!triggers.length) {
      return;
    }

    function partsFor(trigger) {
      return {
        spot: trigger.closest('[data-lpb-spot]'),
        pop: document.getElementById(trigger.getAttribute('aria-controls'))
      };
    }

    function closeAll(except) {
      triggers.forEach(function (trigger) {
        if (trigger === except) {
          return;
        }

        var parts = partsFor(trigger);

        if (parts.spot) {
          parts.spot.classList.remove('is-open');
        }

        if (parts.pop) {
          parts.pop.classList.remove('is-open');
        }

        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();

        var parts = partsFor(trigger);
        var willOpen = trigger.getAttribute('aria-expanded') !== 'true';

        closeAll(trigger);

        if (parts.spot) {
          parts.spot.classList.toggle('is-open', willOpen);
        }

        if (parts.pop) {
          parts.pop.classList.toggle('is-open', willOpen);
        }

        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-lpb-spot]') && !event.target.closest('[data-lpb-spot-pop]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
      }
    });
  }

  sections.forEach(setupFeatureMenu);
  sections.forEach(setupExploreSpots);
})();
